
import {GET_ENV} from "../../redux/types";
import * as axios from "axios";


export const CHANGE_PAGE_HEADER = 'CHANGE_PAGE_HEADER';
export const changePageHeader = (page, leftDrawer) => ({type: CHANGE_PAGE_HEADER, payload: {page, leftDrawer}});

export const SET_MAIN_ELEMENT = 'SET_MAIN_ELEMENT';
export const setMainElement = mainElement => ({type: SET_MAIN_ELEMENT, payload: mainElement});

export const getEnv = () => ({type: GET_ENV});

export const ROUTE_CHANGED = 'ROUTE_CHANGED';
export const routeChanged = () => ({type: ROUTE_CHANGED});


//B
export const GET_API_CONFIG_START = 'GET_API_CONFIG_START';
export const GET_API_CONFIG = 'GET_API_CONFIG';

export const getApiConfig = () => dispatch => {
    dispatch({type: GET_API_CONFIG_START});
    const payload = axios.get('/api/config');
    dispatch({
        type: GET_API_CONFIG,
        payload
    });
};



// WEBPACK FOOTER //
// ./src/containers/app/AppActions.js